import { Theme } from "@mui/material";
import { createStyles, WithStyles, withStyles } from "@mui/styles";
import MuiClickable, { MuiClickableProps } from "components/MuiExtras/MuiClickable";
import * as React from "react";

const styles = (theme: Theme) => createStyles({
    button: {
        padding: theme.spacing(1),
        fontSize: "1rem",
        textTransform: "uppercase",
        "&:hover": {
            backgroundColor: theme.palette.grey[300]
        }
    },
});

interface IProps {
    text?: string;
    startAddorment?: React.ReactNode;
    endAddorment?: React.ReactNode;
}

type Props = IProps & MuiClickableProps & WithStyles<typeof styles>;

const ButtonLink: React.FC<Props> = (props) => {
    const { text, classes, startAddorment, endAddorment, ...rest } = props;
    return (
        <MuiClickable {...rest} className={classes.button}>
            {startAddorment}
            {text && <span>&nbsp;{text}</span>}
            {endAddorment}
        </MuiClickable>
    );
}

export default withStyles(styles)(ButtonLink);